/**
 * PromotionDetailContainer
 * --
 */
import React, { useState, useEffect } from 'react';
import MessageAlert from 'utils';
import { PromotionApi } from 'api';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import PromotionDetailPresenter from './PromotionDetailPresenter';

/**----------------------------------------
 * [Component] 총관리자: 프로모션 상세보기 > 컨테이너
 * ----------------------------------------
 */
const PromotionDetailContainer = ({ permission }) => {
  /* ===== INITIAL ===== */
  const { promotionId } = useParams();

  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [promotionDetail, setPromotionDetail] = useState(null);
  const [productPolicyId, setProductPolicyId] = useState(null);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**--------------------
   * 프로모션 상세 조회
   * --------------------
   */
  const handleGetPromotionDetail = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await PromotionApi.getPromotionsMapping(
        {
          promotion_id: promotionId,
          is_show: 'Y',
          // join_tables: `["promotion_shop", "product_policy"]`,
        }
      );
      if (status !== 200) throw { message };

      setTimeout(() => {
        // setProductPolicyId(data.);
        setPromotionDetail(data[0]);
        setLoading(false);
      }, 750);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    handleGetPromotionDetail();
  }, [promotionId]);

  /* ===== RENDER ===== */
  return (
    <>
      <PromotionDetailPresenter
        loading={loading}
        promotionId={promotionId}
        promotionDetail={promotionDetail}
      />
    </>
  );
};

/* DF */
PromotionDetailContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default PromotionDetailContainer;
